import React, { memo, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import store from "../../../redux/index";
import MessageActions from "../../../redux/message";
import ReactionIcon from "./renderReactionIcon";
import addReactionIcon from "../../../common/icons/add_reaction@2x.png";
var useStyles = makeStyles(function (theme) {
  return {
    iconStyley: {
      height: "24px",
      width: "24px",
      cursor: "pointer"
    },
    conatiner: {
      height: "24px",
      width: "24px",
      "float": function float(props) {
        return props.bySelf ? 'right' : 'left';
      }
    }
  };
});

var Reaction = function Reaction(_ref) {
  var message = _ref.message;
  var classes = useStyles({});

  var _useState = useState(null),
      reactionVisible = _useState[0],
      setReactionVisible = _useState[1];

  var handleClickEmoji = function handleClickEmoji(e) {
    setReactionVisible(e.currentTarget);
  };

  var handleEmojiClose = function handleEmojiClose() {
    setReactionVisible(null);
  };

  var handleEmojiSelected = function handleEmojiSelected(emoji) {
    if (!emoji) return;
    console.log('>>> handleEomji');
    store.dispatch(MessageActions.addReactions(message, emoji));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.conatiner
  }, /*#__PURE__*/React.createElement("img", {
    src: addReactionIcon,
    alt: "reaction",
    className: classes.iconStyley,
    onClick: handleClickEmoji
  }), /*#__PURE__*/React.createElement(ReactionIcon, {
    anchorEl: reactionVisible,
    onSelected: handleEmojiSelected,
    onClose: handleEmojiClose,
    message: message
  }));
};

export default memo(Reaction);